import { render, staticRenderFns } from "./ArchivedCustomFields.vue?vue&type=template&id=5a76e621&"
import script from "./ArchivedCustomFields.vue?vue&type=script&lang=js&"
export * from "./ArchivedCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCustomFields.vue?vue&type=style&index=0&id=5a76e621&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports